export default {
  en:{
    'Full Seat': 'Full Seat',
    'page.title': 'Pricing',
    'page.description': 'Diverse licenses for individuals and organizations. Switch between monthly and annual plans to save more.',
    pricing: 'Pricing',
    planing: 'Choose the Perfect Plan for Your Aviation Training Needs',
    text: 'Flexible pricing for individuals and organizations. Switch between monthly and annual plans to save more.',
    bundle: {
      saving: 'Save {saving} with the bundle',
      bundling: 'The seat is a bundle for most of our licenses.',
      bundlingtext: 'Obtaining this product grants you access to the full learning experience, designed by our smartest minds. The seat is the perfect choice for individuals and small groups, as it provides a comprehensive learning experience at an affordable price.',
      future: 'Future licenses may also be added to the bundle',
      addons: 'Including Add-Ons',
      checkout: 'View product',
      register: 'Register',
      individuall: 'Licenses are also available individually',
      boughtsingle: 'If bought individually',
      itemprice: {
        free: 'For free',
        soon: 'Coming soon',
        from: 'from'
      }
    }
  },
  de: {
    'Full Seat': 'Vollständiger Sitz',
    'page.title': 'Preise',
    'page.description': 'Lizenzen für Einzelpersonen und Organisationen. Wechseln Sie zwischen monatlichen und jährlichen Plänen, um mehr zu sparen.',
    pricing: 'Preise',
    planing: 'Wählen Sie den perfekten Plan für Ihre Flugausbildung',
    text: 'Flexible Preise für Einzelpersonen und Organisationen. Wechseln Sie zwischen monatlichen und jährlichen Plänen, um mehr zu sparen.',
    bundle: {
      saving: 'Sparen Sie {saving} mit dem Bundle',
      bundling: 'Der Sitz ist ein Bundle für die meisten unserer Lizenzen.',
      bundlingtext: 'Der Erwerb dieses Produkts gewährt Ihnen Zugang zu dem vollständigen Lernerlebnis, das von unseren klügsten Köpfen entwickelt wurde. Der Sitz ist die perfekte Wahl für Einzelpersonen und kleine Gruppen, da er ein umfassendes Lernerlebnis zu einem erschwinglichen Preis bietet.',
      future: 'Zukünftige Lizenzen können ebenfalls zum Bundle hinzugefügt werden',
      addons: 'Inklusive Add-Ons',
      checkout: 'Produkt ansehen',
      register: 'Registrieren',
      individuall: 'Lizenzen sind auch einzeln erhältlich',
      boughtsingle: 'Wenn Sie einzeln gekauft haben',
      itemprice: {
        free: 'Kostenlos',
        soon: 'Bald verfügbar',
        from: 'ab'
      }
    }
  },
  es: {
    'Full Seat': 'Asiento completo',
    'page.title': 'Precios',
    'page.description': 'Licencias para individuos y organizaciones. Cambie entre planes mensuales y anuales para ahorrar más.',
    pricing: 'Precios',
    planing: 'Elija el plan perfecto para sus necesidades de formación en aviación',
    text: 'Precios flexibles para individuos y organizaciones. Cambie entre planes mensuales y anuales para ahorrar más.',
    bundle: {
      saving: 'Ahorre {saving} con el paquete',
      bundling: 'El asiento es un paquete para la mayoría de nuestras licencias.',
      bundlingtext: 'Obtener este producto le otorga acceso a la experiencia de aprendizaje completa, diseñada por nuestras mentes más inteligentes. El asiento es la opción perfecta para individuos y grupos pequeños, ya que ofrece una experiencia de aprendizaje integral a un precio asequible.',
      future: 'Las futuras licencias también pueden añadirse al paquete',
      addons: 'Incluyendo complementos',
      checkout: 'Ver producto',
      register: 'Registrarse',
      individuall: 'Las licencias también están disponibles individualmente',
      boughtsingle: 'Si se compró individualmente',
      itemprice: {
        free: 'Gratis',
        soon: 'Próximamente',
        from: 'desde'
      }
    }
  },
  uk: {
    'Full Seat': 'Повний Сидіння',
    'page.title': 'Ціни',
    'page.description': 'Ліцензії для окремих осіб та організацій. Перемикайтеся між щомісячними та річними планами, щоб заощадити більше.',
    pricing: 'Ціни',
    planing: 'Виберіть ідеальний план для ваших потреб у авіаційній підготовці',
    text: 'Гнучкі ціни для окремих осіб та організацій. Перемикайтеся між щомісячними та річними планами, щоб заощадити більше.',
    bundle: {
      saving: 'Заощадьте {saving} з пакетом',
      bundling: 'Місце - це пакет для більшості наших ліцензій.',
      bundlingtext: 'Отримання цього продукту надає вам доступ до повного навчального досвіду, розробленого нашими найрозумнішими умами. Місце - ідеальний вибір для окремих осіб та невеликих груп, оскільки воно забезпечує всебічний навчальний досвід за доступною ціною.',
      future: 'Майбутні ліцензії також можуть бути додані до пакету',
      addons: 'Включаючи доповнення',
      checkout: 'Переглянути продукт',
      register: 'Зареєструватися',
      individuall: 'Ліцензії також доступні окремо',
      boughtsingle: 'Якщо куплено окремо',
      itemprice: {
        free: 'Безкоштовно',
        soon: 'Скоро',
        from: 'від'
      }
    }
  }
}
